export default function HeaderLayout({ children, className }) {
  return <header className={`w-full ${className}`}>{children}</header>
}
